import React from 'react';
// form
// @mui
import { TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { alpha } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import AdapterJalali from '@date-io/date-fns-jalali';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

// ----------------------------------------------------------------------

export default function CustomDatePicker({ ...other }) {
  const theme = useTheme();

  const customIcon = () => {
    return (
      <div
        style={{
          background: alpha(theme.palette.primary.light, 0.15),
          padding: 3,
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          borderRadius: 10,
        }}
      >
      <CalendarMonthIcon sx={{ color: theme.palette.primary.main, borderRadius: 1 }} />
      </div>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterJalali}>
      <DatePicker
        {...other}
        // mask={'____/__/__'}
        inputFormat="yyyy/M/dd"
        disableMaskedInput 
        components={{
          OpenPickerIcon: customIcon,
        }}
        disableOpenPicker={false} 
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            sx={{
              maxWidth: { md: 300 },
            }}
            error={false}
            inputProps={{
              ...params.inputProps,
              readOnly: true,
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
}
